import AllUserDetailsComponent from "./AllUserDetails.container";

export default AllUserDetailsComponent;
